/**
 * Validates a URL string
 */
export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Validates if a URL is safe (basic check)
 */
export const isSafeUrl = (url: string): boolean => {
  if (!isValidUrl(url)) return false;

  // Check if the URL contains suspicious characters
  if (!/^https?:\/\/[a-zA-Z0-9-_.]+\.[a-zA-Z0-9-_.]+/.test(url)) {
    return false;
  }

  return true;
};

/**
 * Sanitizes a URL for use in fetch operations
 */
export const sanitizeUrl = (url: string): string | null => {
  if (!isValidUrl(url)) return null;

  try {
    const urlObj = new URL(url);
    // Only allow http and https protocols
    if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
      return null;
    }
    return url;
  } catch (e) {
    return null;
  }
};
